// GAVION gavion-context: /formation/gavion « Tout sur Gavion » — the « Contexte Gavion » (configuration
// gavion.ai.company_context, else its default), rendered as Markdown, read only, for every signed-in user (the
// configuration row is readable by reps and admins; admins edit it in Paramètres → IA). The same text the AI reads.
import { useGetOne, useTranslate } from "ra-core";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Markdown } from "../../atomic-crm/misc/Markdown";
import { gavionContextOf } from "./gavionContext";

type ConfigRow = { id: number; config?: Record<string, unknown> | null };

export const GavionContextPage = () => {
  const t = useTranslate();
  const q = useGetOne<ConfigRow>("configuration", { id: 1 });
  return (
    <div className="mx-auto w-full max-w-3xl space-y-6 max-md:px-4 max-md:py-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-2xl font-extrabold">
            {t("gavion.training.gavion_page.title")}
          </h1>
          <p className="text-sm text-muted-foreground">
            {t("gavion.training.gavion_page.subtitle")}
          </p>
        </div>
        <Button asChild variant="outline" size="sm">
          <Link to="/formation">{t("gavion.training.gavion_page.back")}</Link>
        </Button>
      </div>
      {q.isPending ? (
        <Skeleton className="h-64 w-full rounded-xl" />
      ) : q.isError ? (
        <p role="alert" className="text-sm text-destructive">
          {t("gavion.training.gavion_page.load_error")}
        </p>
      ) : (
        <article className="rounded-xl border p-4 text-sm">
          <Markdown linksInNewTab>{gavionContextOf(q.data?.config)}</Markdown>
        </article>
      )}
    </div>
  );
};
